<template>
    <span class="text-danger" v-if="mostrarBtnExcluir">
        <i
            class="fa fa-trash fa-lg icon-button ml-1"
            title="Excluir comprometimento"
            @click.stop="confirmarExcluir()"
        ></i>
    </span>
</template>

<script>
import { StatusComprometimento } from './StatusComprometimento'
import { StatusDespesa } from './StatusDespesa'

export default {
    props: {
        despesa: {
            type: Object,
            default: () => ({})
        },

        servicos: {
            type: Object,
            default: () => ({})
        },
    },

    data() {
        return {}
    },

    methods: {
        confirmarExcluir() {
            this.$swal({
                title: 'Exclusão de Comprometimento',
                html: `Confirma a exclusão do comprometimento de ID <b>${this.despesa.idMov}</b>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.excluir()
                }
            })
        },

        excluir() {
            this.$store.dispatch('addRequest')
            this.servicos
                .excluirComprometimento(this.despesa.despesaId)
                .then((response) => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Registro excluído com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('obterAtualizacao')
                        } else {
                            this.$toast.error(
                                'Erro ao excluir comprometimento.',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }
    },

    computed: {
        permiteExcluir() {
            return ( this.$route.name == 'DespesasGerais_Finalizacao_Despesas_Detalhar'
                    && this.$temAcessoView('DESP-GERAIS-FINAL-01'))
                || (this.$route.name == 'DespesasGerais_Requisitantes_Despesas_Detalhar'
                    && this.$temAcessoView('DESP-GERAIS-REQ-04')
                    && this.despesa.statusId != StatusDespesa.APROVADA)
        },

        mostrarBtnExcluir() {
            return (
                !this.despesa.movimentoCompra &&
                this.permiteExcluir &&
                this.despesa.statusIdMov != 'F' &&
                (this.despesa.statusComprometimentoId ==
                    StatusComprometimento.COMPROMETIDO ||
                    this.despesa.statusComprometimentoId ===
                        StatusComprometimento.ATUALIZAR_COMPROMETIMENTO ||
                    (this.despesa.statusComprometimentoId ==
                        StatusComprometimento.ERRO &&
                        this.despesa.idMov))
                && (this.despesa.statusId != StatusDespesa.AGUARDANDO_APROVACAO_DEMANDANTE
                    && this.despesa.statusId != StatusDespesa.AGUARDANDO_APROVACAO_GERENTE)
            )
        }
    }
}
</script>
